<template>
  <v-input
    ref="input"
    v-model.number="localValue"
    type="number"
    class="input--calculator"
    @input="handleInput"
  />
</template>

<script>
export default {
  name: 'VNumberInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
  methods: {
    handleInput(inputValue) {
      this.$emit('input', inputValue);
    },
  },
};
</script>
